module.exports = __webpack_public_path__ + "fonts/Jomolhari.svg";